import { PSEUDO_BY_ID, PSEUDO_ASSIGNEES } from "../constants/enums";

// Resolve an assigned_to id (pseudo or real user) to a display label.
export function assigneeLabel(id, usersById = {}) {
  if (!id) return null;
  if (PSEUDO_BY_ID[id]) return PSEUDO_BY_ID[id].label;
  return usersById[id]?.name || null;
}

// Short badge text (initials for users, short code for teams).
export function assigneeShort(id, usersById = {}) {
  if (!id) return "";
  if (PSEUDO_BY_ID[id]) return PSEUDO_BY_ID[id].short;
  const name = usersById[id]?.name || "";
  return name.split(/\s+/).map((n) => n[0]).filter(Boolean).slice(0, 2).join("").toUpperCase();
}

// Options for filter dropdowns: teams pinned first, then real users.
export function assigneeFilterOptions(users = []) {
  return [
    ...PSEUDO_ASSIGNEES.map((p) => ({ value: p.id, label: `⚑ ${p.label}` })),
    ...users.map((u) => ({ value: u.id, label: u.name })),
  ];
}
